/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDetailRocketWarehouseVo } from './OrderDetailRocketWarehouseVo';
import {
    OrderDetailRocketWarehouseVoFromJSON,
    OrderDetailRocketWarehouseVoFromJSONTyped,
    OrderDetailRocketWarehouseVoToJSON,
    OrderDetailRocketWarehouseVoToJSONTyped,
} from './OrderDetailRocketWarehouseVo';
import type { OrderReceiveAddressVo } from './OrderReceiveAddressVo';
import {
    OrderReceiveAddressVoFromJSON,
    OrderReceiveAddressVoFromJSONTyped,
    OrderReceiveAddressVoToJSON,
    OrderReceiveAddressVoToJSONTyped,
} from './OrderReceiveAddressVo';
import type { OrderDetailWarehouseAndServiceVo } from './OrderDetailWarehouseAndServiceVo';
import {
    OrderDetailWarehouseAndServiceVoFromJSON,
    OrderDetailWarehouseAndServiceVoFromJSONTyped,
    OrderDetailWarehouseAndServiceVoToJSON,
    OrderDetailWarehouseAndServiceVoToJSONTyped,
} from './OrderDetailWarehouseAndServiceVo';
import type { PurchaseCancelReqVo } from './PurchaseCancelReqVo';
import {
    PurchaseCancelReqVoFromJSON,
    PurchaseCancelReqVoFromJSONTyped,
    PurchaseCancelReqVoToJSON,
    PurchaseCancelReqVoToJSONTyped,
} from './PurchaseCancelReqVo';
import type { OrderDetailOrderDetailGoodsVo } from './OrderDetailOrderDetailGoodsVo';
import {
    OrderDetailOrderDetailGoodsVoFromJSON,
    OrderDetailOrderDetailGoodsVoFromJSONTyped,
    OrderDetailOrderDetailGoodsVoToJSON,
    OrderDetailOrderDetailGoodsVoToJSONTyped,
} from './OrderDetailOrderDetailGoodsVo';
import type { ReturnInfoVo1 } from './ReturnInfoVo1';
import {
    ReturnInfoVo1FromJSON,
    ReturnInfoVo1FromJSONTyped,
    ReturnInfoVo1ToJSON,
    ReturnInfoVo1ToJSONTyped,
} from './ReturnInfoVo1';
import type { AdditionalServiceVo } from './AdditionalServiceVo';
import {
    AdditionalServiceVoFromJSON,
    AdditionalServiceVoFromJSONTyped,
    AdditionalServiceVoToJSON,
    AdditionalServiceVoToJSONTyped,
} from './AdditionalServiceVo';
import type { OrderDetailKoreaTrackVo } from './OrderDetailKoreaTrackVo';
import {
    OrderDetailKoreaTrackVoFromJSON,
    OrderDetailKoreaTrackVoFromJSONTyped,
    OrderDetailKoreaTrackVoToJSON,
    OrderDetailKoreaTrackVoToJSONTyped,
} from './OrderDetailKoreaTrackVo';

/**
 * 
 * @export
 * @interface OrderDetailVo
 */
export interface OrderDetailVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof OrderDetailVo
     */
    id?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof OrderDetailVo
     */
    orderCode?: string;
    /**
     * 仓库ID
     * @type {number}
     * @memberof OrderDetailVo
     */
    warehouseId?: number;
    /**
     * 仓库名称
     * @type {string}
     * @memberof OrderDetailVo
     */
    warehouseName?: string;
    /**
     * 订单状态
     * @type {number}
     * @memberof OrderDetailVo
     */
    orderStatus?: number;
    /**
     * 订单状态名称
     * @type {string}
     * @memberof OrderDetailVo
     */
    orderStatusName?: string;
    /**
     * 请求分组
     * @type {string}
     * @memberof OrderDetailVo
     */
    requestGroup?: string;
    /**
     * 结算方式 1 自动结算 2 手动结算
     * @type {number}
     * @memberof OrderDetailVo
     */
    paymentType?: number;
    /**
     * 快递单号数量
     * @type {number}
     * @memberof OrderDetailVo
     */
    trackingNumberCount?: number;
    /**
     * 商品总数量
     * @type {number}
     * @memberof OrderDetailVo
     */
    goodsTotalCount?: number;
    /**
     * 商品总金额
     * @type {number}
     * @memberof OrderDetailVo
     */
    goodsTotalPrice?: number;
    /**
     * 原始商品总金额
     * @type {number}
     * @memberof OrderDetailVo
     */
    originGoodsTotalPrice?: number;
    /**
     * 商品总金额（美元）
     * @type {number}
     * @memberof OrderDetailVo
     */
    goodsTotalAmountUsd?: number;
    /**
     * 原始商品总金额（美元）
     * @type {number}
     * @memberof OrderDetailVo
     */
    originGoodsTotalPriceUsd?: number;
    /**
     * 清关类别
     * @type {string}
     * @memberof OrderDetailVo
     */
    customsClearanceCategory?: string;
    /**
     * 个人或企业清关号
     * @type {string}
     * @memberof OrderDetailVo
     */
    ctmsNo?: string;
    /**
     * 预支付优惠券id
     * @type {number}
     * @memberof OrderDetailVo
     */
    prepayCouponId?: number;
    /**
     * 商品验收前确认要求项
     * @type {string}
     * @memberof OrderDetailVo
     */
    requireBeforeAccept?: string;
    /**
     * 国际运输方式ID
     * @type {number}
     * @memberof OrderDetailVo
     */
    internationalTransportMethodId?: number;
    /**
     * 国际运输方式名称
     * @type {string}
     * @memberof OrderDetailVo
     */
    internationalTransportMethodName?: string;
    /**
     * 用户ID
     * @type {number}
     * @memberof OrderDetailVo
     */
    userId?: number;
    /**
     * 管理员备注
     * @type {string}
     * @memberof OrderDetailVo
     */
    adminRemark?: string;
    /**
     * 请求类型
     * @type {number}
     * @memberof OrderDetailVo
     */
    requestType?: number;
    /**
     * 请求类型名称
     * @type {string}
     * @memberof OrderDetailVo
     */
    requestTypeName?: string;
    /**
     * 
     * @type {PurchaseCancelReqVo}
     * @memberof OrderDetailVo
     */
    purchaseCancel?: PurchaseCancelReqVo;
    /**
     * 订单类型
     * @type {number}
     * @memberof OrderDetailVo
     */
    orderType?: number;
    /**
     * 韩国运输方式ID
     * @type {number}
     * @memberof OrderDetailVo
     */
    krLocalTransportMethodId?: number;
    /**
     * 韩国运输方式名称
     * @type {string}
     * @memberof OrderDetailVo
     */
    krLocalTransportMethodName?: string;
    /**
     * 被退货订单ID
     * @type {number}
     * @memberof OrderDetailVo
     */
    returnOrderId?: number;
    /**
     * 被退货订单编号
     * @type {string}
     * @memberof OrderDetailVo
     */
    returnOrderCode?: string;
    /**
     * 返回方式
     * @type {number}
     * @memberof OrderDetailVo
     */
    returnFromCoupangMentod?: number;
    /**
     * 返回方式名称
     * @type {string}
     * @memberof OrderDetailVo
     */
    returnFromCoupangMentodName?: string;
    /**
     * 商品货位号列表
     * @type {Array<string>}
     * @memberof OrderDetailVo
     */
    locations?: Array<string>;
    /**
     * 初始包装，1 快递袋包装，2 装纸箱， 3 产品原包装
     * @type {number}
     * @memberof OrderDetailVo
     */
    packingStorage?: number;
    /**
     * 购买类型 1 代买 2 转运 3 返送
     * @type {number}
     * @memberof OrderDetailVo
     */
    buyType?: number;
    /**
     * 提货方式
     * @type {number}
     * @memberof OrderDetailVo
     */
    takeGoodsMethod?: number;
    /**
     * 是否是首次订单
     * @type {number}
     * @memberof OrderDetailVo
     */
    firstOrder?: number;
    /**
     * 营业执照号
     * @type {string}
     * @memberof OrderDetailVo
     */
    businessLicenseNumber?: string;
    /**
     * 
     * @type {OrderReceiveAddressVo}
     * @memberof OrderDetailVo
     */
    receiveAddress?: OrderReceiveAddressVo;
    /**
     * 
     * @type {ReturnInfoVo1}
     * @memberof OrderDetailVo
     */
    returnInfo?: ReturnInfoVo1;
    /**
     * 商品列表
     * @type {Array<OrderDetailOrderDetailGoodsVo>}
     * @memberof OrderDetailVo
     */
    goodsList?: Array<OrderDetailOrderDetailGoodsVo>;
    /**
     * 订单当前选中的附加服务列表
     * @type {Array<AdditionalServiceVo>}
     * @memberof OrderDetailVo
     */
    additionalServices?: Array<AdditionalServiceVo>;
    /**
     * 
     * @type {OrderDetailWarehouseAndServiceVo}
     * @memberof OrderDetailVo
     */
    warehouseAndService?: OrderDetailWarehouseAndServiceVo;
    /**
     * 
     * @type {OrderDetailRocketWarehouseVo}
     * @memberof OrderDetailVo
     */
    rocketWarehouseVO?: OrderDetailRocketWarehouseVo;
    /**
     * 分裂出的订单id
     * @type {Array<number>}
     * @memberof OrderDetailVo
     */
    splitOrderIds?: Array<number>;
    /**
     * 管理端订单详情可以显示的按钮
     * @type {Array<string>}
     * @memberof OrderDetailVo
     */
    adminOrderDetailButtons?: Array<string>;
    /**
     * 客户订单详情可以显示的按钮
     * @type {Array<string>}
     * @memberof OrderDetailVo
     */
    clientOrderDetailButtons?: Array<string>;
    /**
     * 韩国运输单列表
     * @type {Array<OrderDetailKoreaTrackVo>}
     * @memberof OrderDetailVo
     */
    koreaTracks?: Array<OrderDetailKoreaTrackVo>;
}

/**
 * Check if a given object implements the OrderDetailVo interface.
 */
export function instanceOfOrderDetailVo(value: object): value is OrderDetailVo {
    return true;
}

export function OrderDetailVoFromJSON(json: any): OrderDetailVo {
    return OrderDetailVoFromJSONTyped(json, false);
}

export function OrderDetailVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDetailVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'warehouseId': json['warehouseId'] == null ? undefined : json['warehouseId'],
        'warehouseName': json['warehouseName'] == null ? undefined : json['warehouseName'],
        'orderStatus': json['orderStatus'] == null ? undefined : json['orderStatus'],
        'orderStatusName': json['orderStatusName'] == null ? undefined : json['orderStatusName'],
        'requestGroup': json['requestGroup'] == null ? undefined : json['requestGroup'],
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'trackingNumberCount': json['trackingNumberCount'] == null ? undefined : json['trackingNumberCount'],
        'goodsTotalCount': json['goodsTotalCount'] == null ? undefined : json['goodsTotalCount'],
        'goodsTotalPrice': json['goodsTotalPrice'] == null ? undefined : json['goodsTotalPrice'],
        'originGoodsTotalPrice': json['originGoodsTotalPrice'] == null ? undefined : json['originGoodsTotalPrice'],
        'goodsTotalAmountUsd': json['goodsTotalAmountUsd'] == null ? undefined : json['goodsTotalAmountUsd'],
        'originGoodsTotalPriceUsd': json['originGoodsTotalPriceUsd'] == null ? undefined : json['originGoodsTotalPriceUsd'],
        'customsClearanceCategory': json['customsClearanceCategory'] == null ? undefined : json['customsClearanceCategory'],
        'ctmsNo': json['ctmsNo'] == null ? undefined : json['ctmsNo'],
        'prepayCouponId': json['prepayCouponId'] == null ? undefined : json['prepayCouponId'],
        'requireBeforeAccept': json['requireBeforeAccept'] == null ? undefined : json['requireBeforeAccept'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'internationalTransportMethodName': json['internationalTransportMethodName'] == null ? undefined : json['internationalTransportMethodName'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'adminRemark': json['adminRemark'] == null ? undefined : json['adminRemark'],
        'requestType': json['requestType'] == null ? undefined : json['requestType'],
        'requestTypeName': json['requestTypeName'] == null ? undefined : json['requestTypeName'],
        'purchaseCancel': json['purchaseCancel'] == null ? undefined : PurchaseCancelReqVoFromJSON(json['purchaseCancel']),
        'orderType': json['orderType'] == null ? undefined : json['orderType'],
        'krLocalTransportMethodId': json['krLocalTransportMethodId'] == null ? undefined : json['krLocalTransportMethodId'],
        'krLocalTransportMethodName': json['krLocalTransportMethodName'] == null ? undefined : json['krLocalTransportMethodName'],
        'returnOrderId': json['returnOrderId'] == null ? undefined : json['returnOrderId'],
        'returnOrderCode': json['returnOrderCode'] == null ? undefined : json['returnOrderCode'],
        'returnFromCoupangMentod': json['returnFromCoupangMentod'] == null ? undefined : json['returnFromCoupangMentod'],
        'returnFromCoupangMentodName': json['returnFromCoupangMentodName'] == null ? undefined : json['returnFromCoupangMentodName'],
        'locations': json['locations'] == null ? undefined : json['locations'],
        'packingStorage': json['packingStorage'] == null ? undefined : json['packingStorage'],
        'buyType': json['buyType'] == null ? undefined : json['buyType'],
        'takeGoodsMethod': json['takeGoodsMethod'] == null ? undefined : json['takeGoodsMethod'],
        'firstOrder': json['firstOrder'] == null ? undefined : json['firstOrder'],
        'businessLicenseNumber': json['businessLicenseNumber'] == null ? undefined : json['businessLicenseNumber'],
        'receiveAddress': json['receiveAddress'] == null ? undefined : OrderReceiveAddressVoFromJSON(json['receiveAddress']),
        'returnInfo': json['returnInfo'] == null ? undefined : ReturnInfoVo1FromJSON(json['returnInfo']),
        'goodsList': json['goodsList'] == null ? undefined : ((json['goodsList'] as Array<any>).map(OrderDetailOrderDetailGoodsVoFromJSON)),
        'additionalServices': json['additionalServices'] == null ? undefined : ((json['additionalServices'] as Array<any>).map(AdditionalServiceVoFromJSON)),
        'warehouseAndService': json['warehouseAndService'] == null ? undefined : OrderDetailWarehouseAndServiceVoFromJSON(json['warehouseAndService']),
        'rocketWarehouseVO': json['rocketWarehouseVO'] == null ? undefined : OrderDetailRocketWarehouseVoFromJSON(json['rocketWarehouseVO']),
        'splitOrderIds': json['splitOrderIds'] == null ? undefined : json['splitOrderIds'],
        'adminOrderDetailButtons': json['adminOrderDetailButtons'] == null ? undefined : json['adminOrderDetailButtons'],
        'clientOrderDetailButtons': json['clientOrderDetailButtons'] == null ? undefined : json['clientOrderDetailButtons'],
        'koreaTracks': json['koreaTracks'] == null ? undefined : ((json['koreaTracks'] as Array<any>).map(OrderDetailKoreaTrackVoFromJSON)),
    };
}

export function OrderDetailVoToJSON(json: any): OrderDetailVo {
    return OrderDetailVoToJSONTyped(json, false);
}

export function OrderDetailVoToJSONTyped(value?: OrderDetailVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'orderCode': value['orderCode'],
        'warehouseId': value['warehouseId'],
        'warehouseName': value['warehouseName'],
        'orderStatus': value['orderStatus'],
        'orderStatusName': value['orderStatusName'],
        'requestGroup': value['requestGroup'],
        'paymentType': value['paymentType'],
        'trackingNumberCount': value['trackingNumberCount'],
        'goodsTotalCount': value['goodsTotalCount'],
        'goodsTotalPrice': value['goodsTotalPrice'],
        'originGoodsTotalPrice': value['originGoodsTotalPrice'],
        'goodsTotalAmountUsd': value['goodsTotalAmountUsd'],
        'originGoodsTotalPriceUsd': value['originGoodsTotalPriceUsd'],
        'customsClearanceCategory': value['customsClearanceCategory'],
        'ctmsNo': value['ctmsNo'],
        'prepayCouponId': value['prepayCouponId'],
        'requireBeforeAccept': value['requireBeforeAccept'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'internationalTransportMethodName': value['internationalTransportMethodName'],
        'userId': value['userId'],
        'adminRemark': value['adminRemark'],
        'requestType': value['requestType'],
        'requestTypeName': value['requestTypeName'],
        'purchaseCancel': PurchaseCancelReqVoToJSON(value['purchaseCancel']),
        'orderType': value['orderType'],
        'krLocalTransportMethodId': value['krLocalTransportMethodId'],
        'krLocalTransportMethodName': value['krLocalTransportMethodName'],
        'returnOrderId': value['returnOrderId'],
        'returnOrderCode': value['returnOrderCode'],
        'returnFromCoupangMentod': value['returnFromCoupangMentod'],
        'returnFromCoupangMentodName': value['returnFromCoupangMentodName'],
        'locations': value['locations'],
        'packingStorage': value['packingStorage'],
        'buyType': value['buyType'],
        'takeGoodsMethod': value['takeGoodsMethod'],
        'firstOrder': value['firstOrder'],
        'businessLicenseNumber': value['businessLicenseNumber'],
        'receiveAddress': OrderReceiveAddressVoToJSON(value['receiveAddress']),
        'returnInfo': ReturnInfoVo1ToJSON(value['returnInfo']),
        'goodsList': value['goodsList'] == null ? undefined : ((value['goodsList'] as Array<any>).map(OrderDetailOrderDetailGoodsVoToJSON)),
        'additionalServices': value['additionalServices'] == null ? undefined : ((value['additionalServices'] as Array<any>).map(AdditionalServiceVoToJSON)),
        'warehouseAndService': OrderDetailWarehouseAndServiceVoToJSON(value['warehouseAndService']),
        'rocketWarehouseVO': OrderDetailRocketWarehouseVoToJSON(value['rocketWarehouseVO']),
        'splitOrderIds': value['splitOrderIds'],
        'adminOrderDetailButtons': value['adminOrderDetailButtons'],
        'clientOrderDetailButtons': value['clientOrderDetailButtons'],
        'koreaTracks': value['koreaTracks'] == null ? undefined : ((value['koreaTracks'] as Array<any>).map(OrderDetailKoreaTrackVoToJSON)),
    };
}

